/** Placeholder de módulos aún no implementados (se reemplaza módulo a módulo en la Etapa B/C). */
import { Construction } from 'lucide-react';
import { Vacio } from '@/componentes/estados.tsx';
import { TituloPagina } from '@/layout/AppLayout.tsx';

export function Pendiente({ titulo, spec }: { titulo: string; spec: string }) {
  return (
    <>
      <TituloPagina titulo={titulo} />
      <Vacio icono={<Construction className="h-6 w-6" />} titulo="Módulo en construcción" descripcion={`Este módulo se implementa según docs/specs/${spec}.md. Tu rol ya tiene el acceso previsto en la matriz.`} />
    </>
  );
}

export function NoEncontrado() {
  return <Vacio titulo="Página no encontrada" descripcion="La ruta no existe o fue movida." />;
}
